export class PostMessgesData {
   action:string;
   data:string;
   height:number;
   width:number;
   embedid:number;
}